import { render } from "./BranchForm.vue?vue&type=template&id=532f7345"
import script from "./BranchForm.vue?vue&type=script&lang=js"
export * from "./BranchForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__